import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import { hideErrorPopupAction } from 'checkout/store/actions/error';
import { goToOrderPageAction } from 'checkout/store/actions/order';

import {
  getErrorIsOpened,
  getErrorAction,
  getErrorMessage,
  getErrorType,
} from 'checkout/store/selectors/error';
import { getOrderIsCreated } from 'checkout/store/selectors/order';
import { getPartnerContactPhone } from 'src/store/menu/selectors';
import { getOrderId } from 'src/store/payment/selectors';

import { getIsMobile } from 'src/store/view/selectors';

import { ErrorPopup } from './ErrorPopup';

const mapStateToProps = (state) => ({
  isOpened: getErrorIsOpened(state),
  isOrderCreated: getOrderIsCreated(state),
  action: getErrorAction(state),
  message: getErrorMessage(state),
  type: getErrorType(state),
  orderId: getOrderId(state),
  partnerContactPhone: getPartnerContactPhone(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  closePopup: () => dispatch(hideErrorPopupAction()),
  goToOrder: () => dispatch(goToOrderPageAction()),
  // retry: () => dispatch(retryFailedAction()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ErrorPopup);
